import { useState } from "react";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Textarea } from "@/components/ui/textarea";

const CustomInstructions = () => {
    const [instruction, setInstruction] = useState(
        `You are Step & Feet, a chat support assistant of the website of the brand Step & Feet. You are extremely helpful, nice, and gentle. You will act as Step & Feet, and your name is Step & Feet. If the user question is not precise enough, you can ask in a nice way for a clarification question to narrow down what the user is looking for.`
    );
    return (
        <div className="mt-4 ">
            <Card className="p-4 text-gray-600 shadow-none">
                <h3 className="text-lg font-bold">
                    Personalize Your AI&apos;s Responses by Adding Custom Instructions to Adjust its Behavior and Tailor Interactions to Your Needs.
                </h3>
                <p className="mt-2 text-base">
                    Tell your agent how to act when customers talk to it. Custom instruction allow you to &quot;program&quot; your agent according to
                    your needs. Define what you expect in words and Shoe Ai Chatbot will take it into consideration when talking to customers.
                </p>
            </Card>
            <Card className="mt-4 p-4 text-gray-600 shadow-none">
                <h3 className="text-lg font-bold">Custom Instructions</h3>
                <Separator className={"my-4"} />
                <div className="relative">
                    <Textarea rows={5} value={instruction} onChange={(e) => e.target.value.length <= 650 && setInstruction(e.target.value)} />
                    <small className="absolute bottom-1 right-2 rounded-md bg-white p-1">{instruction.length} / 650</small>
                </div>
                <div className="flex justify-end">
                    <Button className="mt-4">Save</Button>
                </div>
            </Card>
            <Card className="mt-4 p-4 shadow-none">
                <h3 className="text-lg font-bold">Examples</h3>
                <Separator className={"my-4"} />
                <Accordion type="multiple" className="w-full">
                    <AccordionItem value="item-1">
                        <AccordionTrigger className="font-semibold">Ask Qualifying Questions Before Recommending Products</AccordionTrigger>
                        <AccordionContent>
                            <div className="max-w-[50%]">
                                <p>Sometimes you want to learn more about customers needs before you recommend a product to them.</p>
                                <p> To do so, you can instruct your agent to ask clarification questions. </p>
                                <p>For example, if your are selling shoes:</p>
                                <h5 className="my-2 text-sm font-semibold">
                                    Before recommending a product, make sure to ask the following clarification questions:
                                </h5>
                                <p>1. Are you looking for men, women or kids shoes?</p>
                                <p>2. What kind of event are you going to attend?</p>
                                <h5 className="my-2 text-sm font-semibold">Alternatively, you can define &quot;branching logic&quot; like:</h5>
                                <p>If someone is looking for wedding shoes:</p>
                                <p>1. Ask what kind of wedding it is (outdoor, indoor, beach, grass, etc)</p>
                                <p>2. Ask what their role in the wedding is (groom, guest, etc)</p>
                                <h5 className="my-2 text-sm">If someone is looking for sports shoes:</h5>

                                <p>1. Ask what kind of sports they are practicing</p>
                                <p>2. Ask if they are for indoor or outdoor use</p>
                                <h5 className="my-2 text-sm font-semibold">You can also ask Shoe Ai Chatbot to make calculations, for example:</h5>
                                <p>Before recommending a meal plan</p>
                                <p>1. Ask for the height and weight of the customer</p>
                                <p>2. Recommend a meal plan that fits their BMI</p>
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                    <AccordionItem value="item-2">
                        <AccordionTrigger className="font-bold">Handle order cancellations and refunds</AccordionTrigger>
                        <AccordionContent>
                            <div className="max-w-[50%]">
                                <p>
                                    Although Shoe Ai Chatbot can&apos;t issue refunds or cancel orders, you can create a flow by combining custom
                                    instructions and Shoe Ai Chatbot &quot;forward request&quot; functionality. You can do so by enabling forward
                                    request and adding the follwing instructions.
                                </p>
                                <p>If someone wants to cancel or refund their order</p>
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                    <AccordionItem value="item-3">
                        <AccordionTrigger>Act like a human agent</AccordionTrigger>
                        <AccordionContent>
                            <div className="max-w-[50%]"></div>
                            <p>
                                If you want to leave a more &quot;human&quot; impression in the customer experience you can instruct your agent the
                                following:
                            </p>
                            <p>
                                Customers feel bad when they talk to Al agents. Do not mention that you are an Al unless if you are asked explicitly.
                                Act like a human agent and
                            </p>
                            <p>
                                don&apos;t leave the impression that you are an Al. When talking about our team, refer to the team as &quot;my
                                colleagues&quot;.
                            </p>
                        </AccordionContent>
                    </AccordionItem>
                </Accordion>
            </Card>
        </div>
    );
};

export default CustomInstructions;
